function getClerkPublishableKey(): string {
  // In mock mode, Clerk is not used — return a placeholder to prevent errors
  if (import.meta.env.VITE_MOCK_MODE === 'true') {
    return 'pk_mock_unused';
  }

  const runtimeKey = window.__SHIPLEX_CONFIG__?.clerkPublishableKey;
  if (runtimeKey !== undefined) {
    return runtimeKey;
  }

  const buildTimeKey = String(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '');
  if (buildTimeKey !== '') {
    return buildTimeKey;
  }

  throw new Error('Clerk publishable key not found. Ensure config.js is loaded or VITE_CLERK_PUBLISHABLE_KEY is set.');
}

function getOtelEndpoint(): string | undefined {
  const runtimeEndpoint = window.__SHIPLEX_CONFIG__?.otelEndpoint;
  if (runtimeEndpoint !== undefined) {
    return runtimeEndpoint;
  }

  return import.meta.env.VITE_OTEL_ENDPOINT;
}

export const runtimeConfig = {
  clerkPublishableKey: getClerkPublishableKey(),
  otelEndpoint: getOtelEndpoint()
};
